exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "main[_v-06e7baa9]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}section[_v-06e7baa9]{-ms-flex:1;flex:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-06e7baa9&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/admin/Admin.vue
// module id = 263
// module chunks = 0